import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-md-1" }
const _hoisted_4 = { class: "col-md-1" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "row mb-3 summary"
}
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = { class: "text-muted" }
const _hoisted_23 = ["value", "disabled", "onChange"]
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "text-muted d-block"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 1,
  class: "text-danger d-block"
}
const _hoisted_29 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DeleteReasonDialog = _resolveComponent("DeleteReasonDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createElementVNode("h1", null, "Контроль дублирования контингента ДО", -1)),
    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-muted" }, "Дети, табелируемые в двух и более детских садах с пересекающимися периодами пребывания за отчётный месяц (плановые табели).", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Месяц", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          min: "1",
          max: "12",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.accountingMonth) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.params.accountingMonth,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Год", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          min: "2024",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.accountingYear) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.params.accountingYear,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Населённый пункт", -1)),
        _createVNode(_component_multiselect, {
          modelValue: _ctx.kato,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.kato) = $event)),
          options: _ctx.katoList,
          searchable: true,
          closeOnSelect: true,
          "track-by": "code",
          "custom-label": _ctx.formattedKatoLabel,
          placeholder: "Все",
          multiple: false
        }, null, 8, ["modelValue", "options", "custom-label"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "LMS-система", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.lmsName) = $event)),
          placeholder: "INDIGO, SmartNation…"
        }, null, 512), [
          [_vModelText, _ctx.params.lmsName]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label" }, "Статус проверки", -1)),
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.status) = $event))
        }, [
          _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "Все", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusLabels, (label, value) => {
            return (_openBlock(), _createElementBlock("option", {
              key: value,
              value: value
            }, _toDisplayString(label), 9, _hoisted_8))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.params.status]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label" }, "ИИН / паспорт ребёнка", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.childKey) = $event))
        }, null, 512), [
          [_vModelText, _ctx.params.childKey]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetch(true))),
        disabled: _ctx.loading || !_ctx.params.accountingMonth || !_ctx.params.accountingYear
      }, _toDisplayString(_ctx.loading ? "Загрузка..." : "Поиск"), 9, _hoisted_11),
      _createElementVNode("button", {
        class: "btn btn-outline-secondary ms-2",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fetch(true, true))),
        disabled: _ctx.loading,
        title: "Результат поиска хранится 5 минут; пересчитать по свежим табелям"
      }, "Пересчитать", 8, _hoisted_12),
      _createElementVNode("button", {
        class: "btn btn-warning ms-2",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
      }, "Сбросить фильтры"),
      _createElementVNode("button", {
        class: "btn btn-info ms-2",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.exportXlsx && _ctx.exportXlsx(...args))),
        disabled: _ctx.exporting || _ctx.total === 0
      }, _toDisplayString(_ctx.exporting ? "Формируется..." : "Выгрузить в Excel"), 9, _hoisted_13)
    ]),
    (_ctx.summary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[19] || (_cache[19] = _createElementVNode("b", null, "Детей-дублей:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.summary.children), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[20] || (_cache[20] = _createElementVNode("b", null, "Сумма двойного начисления:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.money(_ctx.summary.totalAmount)) + " ₸", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[21] || (_cache[21] = _createElementVNode("b", null, "Ожидает решения:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.summary.pending), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.total,
      "per-page": _ctx.params.pageSize
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _createVNode(_component_el_table, {
      data: _ctx.rows,
      style: {"width":"100%"},
      border: "",
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "№",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString((_ctx.currentPage - 1) * _ctx.params.pageSize + scope.$index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "childKey",
          label: "ИИН ребёнка",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "fio",
          label: "ФИО ребёнка",
          "min-width": "180"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sides, (side) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: side.key,
            label: side.label,
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "Наименование",
                "min-width": "180"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row[side.key].name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                label: "БИН",
                width: "130"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row[side.key].bin), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                label: "LMS ID",
                width: "110"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row[side.key].lmsId), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                label: "LMS Система",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row[side.key].lmsName), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                label: "Сумма начисления",
                width: "130",
                align: "right"
              }, {
                default: _withCtx((scope) => [
                  (scope.row[side.key].amount != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.money(scope.row[side.key].amount)), 1))
                    : (_openBlock(), _createElementBlock("small", _hoisted_19, "расчёт не выполнен"))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "Итого",
          width: "120",
          align: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("b", null, _toDisplayString(_ctx.money(scope.row.totalAmount)), 1),
            (scope.row.kindergartenCount > 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("small", _hoisted_21, "всего садиков: " + _toDisplayString(scope.row.kindergartenCount), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("small", _hoisted_22, "пересечение: " + _toDisplayString(scope.row.overlapDays) + " дн.", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Статус проверки",
          width: "230"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("select", {
              class: "form-control form-control-sm",
              value: scope.row.status,
              disabled: !_ctx.canEdit,
              onChange: ($event: any) => (_ctx.onStatusPicked(scope.row, $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusLabels, (label, value) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: value,
                  value: value
                }, _toDisplayString(label), 9, _hoisted_24))
              }), 128))
            ], 40, _hoisted_23),
            (scope.row.reviewedAt)
              ? (_openBlock(), _createElementBlock("small", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.reviewedAt)), 1),
                  (scope.row.reviewedByName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " · " + _toDisplayString(scope.row.reviewedByName), 1))
                    : _createCommentVNode("", true),
                  (scope.row.comment)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, ": " + _toDisplayString(scope.row.comment), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (scope.row.stale)
              ? (_openBlock(), _createElementBlock("small", _hoisted_28, "состав садиков изменился после решения"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showStatusDialog,
      "onUpdate:modelValue": [
        _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showStatusDialog) = $event)),
        _ctx.onDialogToggle
      ],
      variant: "restore",
      title: "Изменить статус проверки",
      "confirm-text": "Сохранить",
      "reason-label": "Комментарий",
      loading: _ctx.saving,
      onConfirm: _ctx.confirmStatus
    }, {
      default: _withCtx(() => [
        (_ctx.pending)
          ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
              _createElementVNode("b", null, _toDisplayString(_ctx.pending.row.fio), 1),
              _createTextVNode(" (" + _toDisplayString(_ctx.pending.row.childKey) + ") → ", 1),
              _createElementVNode("b", null, _toDisplayString(_ctx.statusLabels[_ctx.pending.status]), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm", "onUpdate:modelValue"])
  ]))
}